function devtricker_createSuccessToast(text, position = 'bottom', distance = 0) {
    
    const toastElement = document.createElement('div');
    toastElement.id = `comment-success-toast-${crypto.randomUUID()}`;
    toastElement.classList.add('toast');
    toastElement.classList.add('align-items-center');
    toastElement.classList.add('border-0');
    toastElement.classList.add('mt-2');
    
    toastElement.setAttribute('role', 'alert');
    toastElement.setAttribute('aria-live', 'assertive');
    toastElement.setAttribute('aria-atomic', 'true');
    
    toastElement.style.cssText = `position: absolute; ${position}: ${distance}px; left: 50%; transform: translateX(-50%); z-index: 11; background-color: #d4edda; color: #155724;`;

    toastElement.innerHTML = `
        <div class="d-flex">
            <div class="toast-body d-flex align-items-center"><span class='icon icon-check-circle me-1'></span>
                ${text}
            </div>
            <button style="color: #155724;" type="button" class="btn btn-close me-2 m-auto" data-bs-dismiss="toast"
                aria-label="Close">
                <span class=" icon icon-x " style="margin-bottom: 5px;"></span>
            </button>
        </div>
    `;

    return toastElement;
}

function devtricker_createErrorToast(position = 'bottom', distance = 0, message = 'An error occurred. Please try again later.') {
    
    const toastElement = document.createElement('div');
    toastElement.style.zIndex = "999999";
    toastElement.id = `comment-error-toast-${crypto.randomUUID()}`;
    toastElement.classList.add('toast', 'align-items-center', 'border-0', 'mt-2');
    
    toastElement.setAttribute('role', 'alert');
    toastElement.setAttribute('aria-live', 'assertive');
    toastElement.setAttribute('aria-atomic', 'true');
    
    toastElement.style.cssText = `position: absolute; ${position}: ${distance}px; left: 50%; transform: translateX(-50%); z-index: 11; background-color: #f8d7da; color: #721c24;`;

    toastElement.innerHTML = `
        <div class="d-flex">
            <div class="toast-body d-flex align-items-center">
                <span class='icon icon-alert-circle me-1'></span>
                ${message}
            </div>
            <button style="color: #721c24;" type="button" class="btn btn-close me-2 m-auto" data-bs-dismiss="toast"
                aria-label="Close">
                <span class="icon icon-x" style="margin-bottom: 5px;"><span>
            </button>
        </div>
    `;

    return toastElement;
}

if (typeof crypto.randomUUID !== 'function') {
    crypto.randomUUID = function() {
        if (typeof crypto.getRandomValues === 'function') {
            const buffer = new Uint8Array(16);
            crypto.getRandomValues(buffer);

            buffer[6] = (buffer[6] & 0x0f) | 0x40;
            buffer[8] = (buffer[8] & 0x3f) | 0x80;

            const hexParts = Array.from(buffer).map(b => b.toString(16).padStart(2, '0'));
            return [
                hexParts.slice(0, 4).join(''),
                hexParts.slice(4, 6).join(''),
                hexParts.slice(6, 8).join(''),
                hexParts.slice(8, 10).join(''),
                hexParts.slice(10, 16).join('')
            ].join('-');
        } else {
            //console.warn('crypto.getRandomValues is not available; using Math.random().');
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0;
                const v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
    };
}